import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import withWeightModifiers from "../withWeightModifiers/index.js";
import styles from "../../font-scale-categories.css";
const classes = {
  body1: styles.body1,
  body2: styles.body2
};

/**
 * This component also supports the font weight modifier props.
 */
const Body = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    as: ComponentToRender,
    level,
    ...props
  } = _ref;
  const bodyClass = `body${level}`;
  return /*#__PURE__*/React.createElement(ComponentToRender, _extends({
    ref: ref,
    className: `${className} ${classes[bodyClass]}`
  }, props));
});
Body.defaultProps = {
  className: '',
  as: 'div'
};
process.env.NODE_ENV !== "production" ? Body.propTypes = {
  /**
   * Additional classes to apply
   */
  className: PropTypes.string,
  /**
   * Component to render.
   */
  as: PropTypes.elementType,
  /**
   * Body level to render. Must be a number from 1 through 2
   */
  level: PropTypes.oneOf([1, 2]).isRequired
} : void 0;
export default withWeightModifiers(Body);